// projects/humanresources-personnel/src/assets/i18n/*/hr-per-vehicle.json
export class HrPerVehicleKey {
    private static readonly keyPrefix = 'hrPerVehicle';
    public static title = `${HrPerVehicleKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerVehicleKey.keyPrefix}.pageHeader`;
    public static selectMake = `${HrPerVehicleKey.keyPrefix}.selectMake`;
    public static model = `${HrPerVehicleKey.keyPrefix}.model`;
    public static vehicleHrmType = `${HrPerVehicleKey.keyPrefix}.vehicleHrmType`;
    public static modelYear = `${HrPerVehicleKey.keyPrefix}.modelYear`;
    public static color = `${HrPerVehicleKey.keyPrefix}.color`;
    public static plateNumber = `${HrPerVehicleKey.keyPrefix}.plateNumber`;
    public static make = `${HrPerVehicleKey.keyPrefix}.make`;
}
